const AlertConstants = {
  SUCCESS: 'ALERT_SUCCESS',
  ERROR: 'ALERT_ERROR',
  CLEAR: 'ALERT_CLEAR',
  INFO: 'ALERT_INFO',
};

export default AlertConstants;
